import { IoDocumentTextOutline } from "react-icons/io5";

type EmptyStateProps = {
  icon?: React.ReactNode;
  title: string;
  description: string;
  actionButton?: React.ReactNode;
};

export const EmptyState = ({
  icon,
  title,
  description,
  actionButton,
}: EmptyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-12 px-4">
      <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-gray-100 flex items-center justify-center mb-4">
        {icon || <IoDocumentTextOutline className="text-3xl md:text-4xl text-gray-400" />}
      </div>
      <h3 className="text-base md:text-lg font-semibold text-gray-800 mb-2 text-center">
        {title}
      </h3>
      <p className="text-sm md:text-base text-gray-500 text-center max-w-sm mb-4">
        {description}
      </p>
      {actionButton && <div className="mt-2">{actionButton}</div>}
    </div>
  );
};
